import { Typography } from '@mui/material';

import { FinancialColumnId } from '../../../constants/columns';

export const renderCellContent = (
  columnId: string,
  isFirstColumn: boolean,
  total: number,
) => {
  if (isFirstColumn) {
    return <Typography fontWeight={700}>Total:</Typography>;
  }

  if (columnId === FinancialColumnId.Amount) {
    return (
      <Typography fontWeight={700}>
        {total.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })}
      </Typography>
    );
  }

  return null;
};
